export type JwtPayload = {
	aud: string | string[],
	[key: string]: unknown,
}

// Browser-compatible JWT payload decoder.
// Handles UTF-8 characters (e.g. emojis in user names) that break raw atob().
export const getJwtPayload = (
	token: string,
): JwtPayload => {
	const base64Url = token.split( '.' )[ 1 ]

	if ( !base64Url ) {
		throw new Error( 'Invalid JWT: missing payload segment' )
	}

	const base64 = base64Url.replace( /-/g, '+' ).replace( /_/g, '/' )

	try {
		const jsonPayload = decodeURIComponent(
			atob( base64 )
				.split( '' )
				.map( ( c ) => '%' + ( '00' + c.charCodeAt( 0 ).toString( 16 ) ).slice( -2 ) )
				.join( '' ),
		)

		return JSON.parse( jsonPayload )
	} catch {
		throw new Error( 'Invalid JWT: malformed payload' )
	}
}
